import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AppConfig } from './app-config';

@Injectable({
  providedIn: 'root'
})

export class AppConfigService {
  private appConfig: AppConfig;

  constructor(private http: HttpClient) {
  }

  loadAppConfig() { 
    return firstValueFrom(this.http.get<AppConfig>("/api/Configuration")).then(data => {
      this.appConfig = data;
    })
  }

  getConfig() {
    return this.appConfig;
  }

  isProd() {
    return this.appConfig.environment.toUpperCase() == "PROD";
  }

  getConfigByKey(Key: string) {
    if (Key == "forms")
      return this.appConfig.formsApiUrl;
    else if (Key == "rent") {
      return this.appConfig.rentApiUrl;
    }
    else if (Key == "core") {
      return this.appConfig.coreApiUrl;
    }
    else if (Key == "portal") {
      return this.appConfig.portalApiUrl;
    }
    else if (Key == "portalProgramID") {
      return this.appConfig.portalProgramID;
    }
    else if (Key == "appeals") {
      return this.appConfig.appealsApiUrl;
    }
    else if (Key == "timeout_in_minutes") {
      return this.appConfig.timeout_in_minutes;
    }
    else if (Key == "portalApiKey") {
      return this.appConfig.portalApiKey;
    }
    else if (Key == "environment") {
      return this.appConfig.environment;
    }
    else if (Key == "rentApiKey") {
      return this.appConfig.rentApiKey;
    }
    else if (Key == "appealsApiKey") {
      return this.appConfig.appealsApiKey;
    }
    else if (Key == "botSecretKey") {
      return this.appConfig.botSecretKey;
    }
    else if (Key == "dsnap") {
      return this.appConfig.dsnapApiUrl;
    }
  }
}
